module.exports = __webpack_public_path__ + "static/media/email-gray.5f2b6c09.svg";